import React, { FC, useEffect } from "react";
import userManager, { signoutRedirect } from "src/oidcClient/userService";

const Logout: FC = () => {
    useEffect(() => {
        const logout = async () => {
            try {
                
                await signoutRedirect();
                // Office.context.ui.messageParent("logout");
                console.log("Logout successful");
            } catch (error) {
                console.error(error);
            }
        };
        logout();
        console.log("Logout...", userManager.getUser());
    }, []);
    return <div>Logout...</div>;
};

export default Logout;

// signoutRedirect()
//             .then(() => Office.context.ui.messageParent("logout"))
//             .catch(e => console.error(e));
